import request from '@/utils/request';



export default {
    // 关联数据列表
    getRmcReferenceList: (param) => {
        return request({
            url: `/rmc/protein/asl/rmcReferenceList/${param}`,
            method: 'post',
        });
    },
    // Category3列表
    getCategory3: (param) => {
        return request({
            url: `/downloadList`,
            method: 'post',
            data: param
        });
    },
    // asl分页查询
    getAslData: (param) => {
        return request({
            url: `/rmc/protein/asl/list`,
            method: 'post',
            data: param
        });
    },
    getAslDataAll: (param) => {
        return request({
            url: `/rmc/protein/asl/listAll`,
            method: 'post',
            data: param
        });
    },
    // asl列表详情
    aslDetail: (param, id) => {
        return request({
            url: `/rmc/protein/asl/detail/${id}`,
            method: 'post',
            data: param
        });
    },
    // 添加asl
    addAsl: (param, id) => {
        return request({
            url: `/rmc/protein/asl/create`,
            method: 'post',
            data: param
        });
    },
    // 更新保存asl
    saveAsl: (param, id) => {
        return request({
            url: `/rmc/protein/asl/update/${id}`,
            method: 'post',
            data: param
        });
    },
    // 提交asl
    submitAsl: (param, id) => {
        return request({
            url: `/rmc/protein/asl/submit/${id}`,
            method: 'post',
            data: param
        });
    },
    // aslgroup
    aslGroup: (param, id) => {
        return request({
            url: `/rmc/protein/asl/aslGroupList?sponsor=${id}`,
            method: 'post',
            data: param
        });
    },
    // 获取全部的aslgroup列表
    allAslGroup: (param, id) => {
        return request({
            url: `/rmc/protein/asl/allAslGroupList?sponsor=${id}`,
            method: 'post',
            data: param
        });
    },
    // asl删除
    aslDelete: (param) => {
        return request({
            url: `/rmc/protein/asl/delete`,
            method: 'post',
            data: param
        });
    },
    // asl启用
    aslActive: (param) => {
        return request({
            url: `/rmc/protein/asl/active`,
            method: 'post',
            data: param
        });
    },
    // asl禁用
    aslInactive: (param) => {
        return request({
            url: `/rmc/protein/asl/inactive`,
            method: 'post',
            data: param
        });
    },
    // Sponsor查询
    qspiSponsorList: (param) => {
        return request({
            url: `/rmc/qspiSponsorList`,
            method: 'post',
            data: param
        });
    },
    // 生成待办任务
    generateTodoList: (param) => {
        return request({
            url: `/rmc/protein/asl/generateTodoList`,
            method: 'post',
            data: param
        });
    },
    // 删除待办任务
    deleteTodoList: (param) => {
        return request({
            url: `/rmc/protein/asl/deleteTodoList`,
            method: 'post',
            data: param
        });
    },
    // 导出
    downloadAsl: (param) => {
        return request({
            url: `/rmc/protein/asl/downloadAsl`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 查询操作日志
    queryActionList: (param) => {
        return request({
            url: `/rmc/protein/asl/actionList`,
            method: 'post',
            data: param,
        });
    },
    // ASL授权配置查询列表
    getAslAuthConfigQuery: (param) => {
        return request({
            url: "/rmc/protein/asl/breedingConfigQuery",
            method: 'post',
            data: param
        })
    },
    // 保存ASL授权配置
    saveAslAuthConfig: (param) => {
        return request({
            url: "/rmc/protein/asl/breedingConfigSave",
            method: 'post',
            data: param
        })
    },
    // 删除ASL授权配置
    deleteAslAuthConfig: (param) => {
        return request({
            url: "/rmc/protein/asl/breedingConfigDelete",
            method: 'post',
            data: param
        })
    }
}



